export const formatNumberWithCommas = (number) => {
  if (typeof number === "number") {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return number;
};

export const sanitizePayload = function (payload) {
  Object.entries(payload).forEach(([key, val]) => {
    if (val === undefined || val === null || val === "") delete payload[key];
  });
  return payload;
};
